module.exports = __webpack_public_path__ + "static/media/portrait.facb2a35.jpg";